import { render } from "./SolumLayout.vue?vue&type=template&id=3e52149b&scoped=true"
import script from "./SolumLayout.vue?vue&type=script&lang=js"
export * from "./SolumLayout.vue?vue&type=script&lang=js"

import "./SolumLayout.vue?vue&type=style&index=0&id=3e52149b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e52149b"]])

export default __exports__